<template>
  <Encabeza/>
  <v-card>
    <v-card-title>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>


    </v-card-title>
    <v-data-table :headers="headers" :items="registros" :search="search">
      <template v-slot:[`item.status`]="{ item }">
        <v-btn @click="activarUsuarioplus(item)" :color="item.status ? 'red' : 'green'" small style="width: 120px;">
          {{ item.status ? 'Desactivar' : 'Activar' }}
        </v-btn>

      </template>
      <template v-slot:[`item.actions`]="{ item }">
            <v-icon @click="abrirDialogo(item)" class="m-1" color="cyan-lighten-1" icon="mdi-eye">
            </v-icon>
            <v-icon @click="editForm(item)" class="m-1" color="green-darken-2" icon="mdi-pencil">
            </v-icon>
            <v-icon @click="deleteItem(item)" color="red" class="m-1" icon="mdi-delete">
            </v-icon>
          </template>
    </v-data-table>
  </v-card>

  <AdminFormPage :dialogoAbierto="dialogoAbierto" @guardarUsuario="guardarUsuario" @cerrarDialogo="cerrarDialogo"
    @abrirDialogo="abrirDialogo" />
</template>

<script>
import { defineComponent } from 'vue';
import Usuario from "@/services/Usuario";
import { VDataTable } from 'vuetify/labs/VDataTable'
import AdminFormPage from './AdminFormPage.vue';
import Encabeza from "@/components/EncabezadoPage.vue";

export default defineComponent({
  name: 'AdminPage',
  components: {
    VDataTable,
    AdminFormPage,
    Encabeza,
  },
  data() {
    var registros;
    const usuario = new Usuario();

    return {
      registros,
      cedula: '',
      nombreCompleto: '',
      usuario,
      search: '',
      dialogoAbierto: false,
      headers: [
        { align: 'start', key: 'name', sortable: false, },
        { key: 'nombres', title: 'Nombres' },
        { key: 'correo', title: 'Correo' },
        { key: 'nombre_rol', title: 'Rol' },
        { key: 'status', title: 'Estado' },
        { title: "Acciones", key: "actions", sortable: true, width: 150 },
      ],
    }
  },
  methods: {
    abrirDialogo() {
      this.dialogoAbierto = true;
    },
    cerrarDialogo() {
      this.dialogoAbierto = false;
    },
    guardarUsuario() {
      // Realiza las acciones de guardado
      this.cerrarDialogo(); // Cierra el modal al guardar
    },
    async activarUsuarioplus(item) {
      this.usuarioSeleccionado = item;
      try {
        await this.usuario.desactivaractivarUsuario(item.id);
        this.registros = await this.usuario.index();
        console.log("Usuario Cambiado", this.registros);
      } catch (error) {
        console.error(error);
      }
    },
  },

  async mounted() {
    this.registros = await this.usuario.index();
  },
  async buscarUsuario() {
    if (this.cedula) {
      try {
        const usuario = await Usuario.buscarPorCedula(this.cedula);
        // La respuesta debe ser un objeto que contiene la propiedad "nombreCompleto"
        this.nombreCompleto = usuario.nombreCompleto;
      } catch (error) {
        console.error(error);
      }
    }
  }
});
</script>